/** API route map: URLS.Controller.ClientWcBillingStateRule */
export const ClientWcBillingStateRule = {
      Name: 'ClientWcBillingStateRule/',
      GetAll: 'get-all',
      Add: 'create',
      Delete: 'delete',
};
